<template>
  <div class="game-selector">
    <div class="game-selector__select" @click="openGameSelect">
      <p>{{ selectedGameLabel }}</p>
      <img
        :class="{ rotate: gameSelectOpen }"
        src="../../../assets/images/down-arrow.svg"
        alt="open"
      />
    </div>
    <div class="game-selector__select__dropDown" v-if="gameSelectOpen">
      <span
        class="game-selector__select__dropDown__item"
        v-for="game in games"
        :key="game.value"
        @click="selectGame(game.value)"
      >
        {{ game.label }}
      </span>
    </div>
  </div>
</template>

<script>
import { Games, GamesNames } from '@/constants'

import './game-selector.scss'

export default {
  name: 'GameSelector',
  props: {
    selectedGame: {
      type: Number
    }
  },
  data() {
    return {
      gameSelectOpen: false,
      games: Object.values(Games).map((game) => {
        return {
          value: game,
          label: GamesNames[game]
        }
      })
    }
  },
  computed: {
    selectedGameLabel() {
      return this.games.find((game) => game.value === this.selectedGame)?.label || 'Select a game'
    }
  },
  methods: {
    selectGame(gameValue) {
      this.gameSelectOpen = false
      this.$emit('select', { game: gameValue })
    },
    openGameSelect() {
      this.gameSelectOpen = !this.gameSelectOpen
    }
  }
}
</script>
